
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pergolas/[slug]",
      function () {
        return require("private-next-pages/pergolas/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pergolas/[slug]"])
      });
    }
  